// Building an Intl.DateTimeFormat costs far more than formatting with one, and
// timing code asks for offsets per cue. One formatter per timezone, kept for good:
// there are only a few hundred IANA zones.
const offsetFormats = new Map<string, Intl.DateTimeFormat>()

function getOffsetFormat(timezone: string): Intl.DateTimeFormat {
  let format = offsetFormats.get(timezone)
  if (!format) {
    format = new Intl.DateTimeFormat('en', {
      timeZone: timezone,
      timeZoneName: 'longOffset', // Note: Typescript parser may be outdated, 'longOffset' is valid
    })
    offsetFormats.set(timezone, format)
  }
  return format
}

/**
 * Get the timezone offset for a given date and timezone.
 *
 * @param {string} timezone - The IANA timezone string (e.g., 'Australia/Sydney')
 * @param {Date} date - The date to get the offset for
 *
 * @returns {number} The offset in milliseconds
 */
export function getTimezoneOffset(timezone: string, date: Date): number {
  if (!(date instanceof Date)) throw new Error('`date` must be a valid Date')
  if (typeof timezone !== 'string') throw new Error('`timezone` must be provided')

  const offsetStr = getOffsetFormat(timezone).format(date).split(', ')[1]
  if (!offsetStr) throw new Error('Unable to parse timezone offset')

  // Parse offsetStr into milliseconds
  const match = offsetStr.match(/GMT(?:([+-]\d{2}):(\d{2}))?/)
  if (!match) throw new Error('Unable to parse timezone offset')
  if (!match[1]) return 0
  const hours = parseInt(match[1], 10)
  const minutes = parseInt(match[2]!, 10)

  const offset = (hours * 60 + minutes) * 60 * 1000

  return offset
}
